import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';
import { UseArtworksByArtistResult } from '../types';

export const useArtworks = (params?: {
  page?: number;
  limit?: number;
  artist_id?: string;
  featured?: boolean;
}) => {
  return useQuery({
    queryKey: ['artworks', params],
    queryFn: () => apiService.getArtworks(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useArtworksByArtist = (artistId: string): UseArtworksByArtistResult => {
  const {
    data,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['artworks', 'by-artist', artistId],
    queryFn: () => apiService.getArtworks({ artist_id: artistId, limit: 100 }),
    enabled: !!artistId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    artworks: data?.data || [],
    isLoading,
    error: error as Error | null,
    refetch
  };
};